/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Table_EventsInputs */

const en_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Events`)
};

const fr_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des événements`)
};

const de_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtereignisse`)
};

const it_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi totali`)
};

const ru_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий`)
};

const es_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

const zh_cn2_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件`)
};

const ja_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント数`)
};

const hi_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल घटनाएँ`)
};

const pt_pt2_automatic_save_table_events = /** @type {(inputs: Automatic_Save_Table_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Automatic_Save_Table_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_table_events = /** @type {((inputs?: Automatic_Save_Table_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Table_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_table_events(inputs)
	if (locale === "de") return de_automatic_save_table_events(inputs)
	if (locale === "it") return it_automatic_save_table_events(inputs)
	if (locale === "ru") return ru_automatic_save_table_events(inputs)
	if (locale === "es") return es_automatic_save_table_events(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_table_events(inputs)
	if (locale === "ja") return ja_automatic_save_table_events(inputs)
	if (locale === "hi") return hi_automatic_save_table_events(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_table_events(inputs)
	return en_automatic_save_table_events(inputs)
});